import ImageURL from 'components/Image';

import * as S from './styles';
import getPropsImage from './types';

type HeaderLogoProps = {
  productId: number;
};

const HeaderLogo = ({ productId }: HeaderLogoProps) => {
  const imageProps = getPropsImage(productId);

  if (!imageProps.file) return null;

  return (
    <S.Wrapper>
      <ImageURL
        src={`/tcstore/images/logos/lp/${imageProps.file}`}
        alt={`Logo do produto ${imageProps.alt}`}
        width={223}
        height={52}
      />
    </S.Wrapper>
  );
};

export default HeaderLogo;
